import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { FiPlus } from "react-icons/fi";
import axios from "axios";
import useTranslations from "../../hooks/useTranslations";
import useUserLanguage from "../../hooks/useUserLanguage";

axios.defaults.baseURL = process.env.REACT_APP_API_BASE_URL;

const DualResultsHeader = () => {
  const { testId: testId } = useParams(); // /test/dual-results/:id route’undan geliyor
  const [perm, setPerm] = useState({});
  const lang = useUserLanguage();
  const { translations } = useTranslations(lang);
  const t = (k, d) => translations[k] || d;

  useEffect(() => {
    (async () => {
      try {
        const token = localStorage.getItem("admin_token");
        const { data } = await axios.get("/api/admin/my-permissions", {
          headers: { Authorization: `Bearer ${token}` },
        });
        const p =
          data.permissions?.find(
            (p) => p.module_key === "dual_results"
          ) || {};
        setPerm(p);
      } catch {
        setPerm({});
      }
    })();
  }, []);

  const canCreate = perm.create_permission || perm.full_access;

  return (
    <div className="d-flex align-items-center gap-2 page-header-right-items-wrapper">
      {  (
        <Link to={`/test/dual-results/create/${testId}`} className="btn btn-primary">
          <FiPlus size={16} className="me-2" />
          {t("DUAL_RESULT_CREATE", "Yeni Sonuç")}
        </Link>
      )}
    </div>
  );
};

export default DualResultsHeader;
